import { Component, Inject } from '@angular/core';
import { ServerAPI } from '../../serverapi';
import { ActivatedRoute, Router } from '@angular/router';
import loadLibrary, { cKopConfig, JSBridge, MainModule } from '@wasm/KopWeb';
import { makeAvailable } from '../jsbridge.service';

@Component({
  selector: 'new-kop',
  templateUrl: './new-kop.component.html',
  styles: ``
})
export class NewKopComponent {

  constructor(@Inject('ServerApi') public electronAPI: ServerAPI, private route: ActivatedRoute, private router: Router) {
    this.route.params.subscribe(params => {
      this.klantNo = params['klantNo'];

      this.initKop();
    });
  }



  private async initKop() {
    let filePath = `SXB/${this.klantNo}.SXB`;
    let serverData = await this.electronAPI.loadKop(this.klantNo, undefined);
    if (serverData != undefined && serverData.sxbData != undefined) {
      this.router.navigate([`/SXB/${this.klantNo}`]);
      return;
    }
    let library = await loadLibrary();
    await makeAvailable('db/KopData.db', library, this.electronAPI);
    await makeAvailable('db/KopData_en.db', library, this.electronAPI);
    await makeAvailable('db/KopTrans.db', library, this.electronAPI);
    let bridge = new library.JSBridge(this.klantNo);
    bridge.getConfig().klimaatVersion.str = "27-1A";
    bridge.save();

    var data = library.FS.readFile('/working/' + filePath, {
      encoding: 'binary'
    });
    await this.electronAPI.saveFile(filePath, data);
    this.router.navigate([`/SXB/${this.klantNo}`]);
  }

  public klantNo = "ZZ0000";

}
